type RequestError = {
  message?: string;
  data?: any;
  type?: string;
  code?: number;
} | null;

interface RequestOptions {
  url: string;
  data?: {
    [key: string]: any;
  };
  dataType?: string;
  responseDataKey?: string;
  method?: string;
  params?: any;
  header?: any;
}

interface Params {
  url: string;
  data: any;
  params?: any;
  method?: string;
  headers?: any;
  dataType?: string;
}

const requestDataAnalysis = <T>(opions: RequestOptions): Promise<[null, T] | [RequestError]> => {
  const Network = Mach.requireModule('Network');
  return new Promise((resolve) => {
    const {
      url, data = {}, method = 'POST', params
    } = opions;
    const requestParams: Params = {
      url,
      params,
      data,
      method,
      dataType: 'json',
    };
    Network.request(requestParams, (result) => {
      const { data, error } = result;

      console.log('====================================');
      console.log('result', result);
      console.log('====================================');
      if (!error) {
        const { error: rawError } = data || {};
        if (rawError) {
          resolve([rawError]);
        } else {
          resolve([null]);
        }
        return;
      }
      // customMonitor.setLoginProcessCode(requestErrorCode)
      resolve([{ type: 'network module request error' }]);
    });
    // customMonitor.reportStartRequest(customMonitorLoginType.PHONE, customMonitorState.START, verifyType, "-999", url);
  });
};

export { requestDataAnalysis };
